module.exports = __webpack_public_path__ + "images/Boat.cd16cfe85d26f15a408f49673cc40e62.svg";